import Vue from 'vue'
import Vuex from 'vuex'
import User from '../services/http/User'
import TruckType from '../services/http/TruckType'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userMeta: {
      company: null
    },
    truckType: []
  },
  mutations: {
    checkCompanyStatus (state, data) {
      state.userMeta.company = data
    },
    loadTruckType (state, data) {
      state.truckType = data
    }
  },
  actions: {
    async checkCompanyStatus (context) {
      var user = new User()
      try {
        var companyStatus = await user.checkStatus()
        if (companyStatus.code === 1) {
          var companyData = companyStatus.data
        } else {
          alert('Error')
          return
        }
      } catch (error) {
        console.log(error)
        alert('ไม่สามารถเตรียมพร้อมข้อมูลได้')
        return
      }
      context.commit('checkCompanyStatus', companyData)
    },
    async loadTruckType (context) {
      var truckType = new TruckType()
      try {
        var truckTypeData = await truckType.getAllTruckType()
        if (truckTypeData.code === 1) {
        } else {
          alert('Error')
          return
        }
      } catch (error) {
        console.log(error)
        alert('ไม่สามารถเตรียมพร้อมข้อมูลได้')
        return
      }

      context.commit('loadTruckType', truckTypeData.data)
    }
  },
  modules: {
  }
})
